import { createInjectionState } from '@vueuse/core'
import { ref } from 'vue'

const [useProvideTeleprompter, _useTeleprompter] = createInjectionState(() => {
  const isEditing = ref(false)

  return {
    isEditing,
  }
})

function useTeleprompter() {
  const res = _useTeleprompter()
  if (!res) {
    throw new Error('useTeleprompter must be used within a TeleprompterProvider.')
  }

  return res
}

export {
  useProvideTeleprompter,
  useTeleprompter,
}
